module.exports = __webpack_public_path__ + "static/media/weekendPaceChiliFire.eb98f00b.png";